const MuteSound = () => {
  return (
    <svg
      width="96"
      height="96"
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="96" height="96" rx="48" />
      <path
        d="M55.9129 37.3874V34.7048C55.9129 26.3776 50.1285 23.192 43.0867 27.6071L34.9271 32.7208C34.0329 33.2517 32.999 33.5591 31.965 33.5591H27.9691C22.3803 33.5591 19.5859 36.3535 19.5859 41.9423V53.1198C19.5859 58.7085 22.3803 61.5029 27.9691 61.5029H33.5578"
        stroke="black"
        strokeWidth="4.23569"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.0879 67.4558C50.1297 71.8709 55.9141 68.6574 55.9141 60.3581V50.1865"
        stroke="black"
        strokeWidth="4.23569"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M66.5603 40.3218C69.0753 46.3297 68.3208 53.3436 64.2969 58.7088"
        stroke="black"
        strokeWidth="4.23569"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M73.1007 35.7954C77.2084 45.5478 75.9789 56.9489 69.4121 65.6953"
        stroke="black"
        strokeWidth="4.23569"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M75.4833 20.0688L19.5957 75.9564"
        stroke="black"
        strokeWidth="4.23569"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default MuteSound;
